function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import _ from 'lodash';
import { saveAs } from 'file-saver';
import { loadPayment } from 'researcher/payment/actions';
import { loadUserInvoicingData } from 'researcher/user/actions';
import { RUBRIQ_SYNCED } from 'rubriq/constants';
import featureEnabled from 'shared/helper/feature';
import * as c from './constants';
export var archiveDigitalEdit = function archiveDigitalEdit(digitalEditIdentity, fileName) {
  var removeOnSuccess = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  return function (dispatch, getState, _ref) {
    var application = _ref.application;
    return dispatch(application.post("/api/digital-edit/".concat(digitalEditIdentity, "/archive"))).then(function () {
      if (removeOnSuccess) {
        dispatch(removeDigitalEdit(digitalEditIdentity));
      }
      dispatch(application.addMessage({
        type: 'success',
        message: '%(fileName)s deleted',
        params: {
          fileName: fileName
        }
      }));
    });
  };
};
export var createDigitalEdit = function createDigitalEdit(digitalEditUpdateRequest) {
  var showError = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var searchOnSuccess = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  return function (dispatch, getState, _ref2) {
    var application = _ref2.application;
    return dispatch(application.post('/api/digital-edit/create', digitalEditUpdateRequest)).then(function (json) {
      var error = json.error;
      if (error) {
        if (showError) {
          dispatch(application.addMessage({
            type: 'error',
            message: error.error,
            params: JSON.parse(error.getJsonEncodedParams() || '{}')
          }));
        }
      } else if (searchOnSuccess) {
        // If we successfully upload a digital edit, let's add it to the page
        dispatch(searchDigitalEdits({
          page: 1
        }));
      }
      return json;
    });
  };
};
export var getDownloadUrl = function getDownloadUrl(digitalEditIdentity, fileName) {
  var _ref3 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
    _ref3$isPdf = _ref3.isPdf,
    isPdf = _ref3$isPdf === void 0 ? false : _ref3$isPdf,
    _ref3$isClean = _ref3.isClean,
    isClean = _ref3$isClean === void 0 ? false : _ref3$isClean;
  return function (dispatch, getState, _ref4) {
    var application = _ref4.application;
    var downloadFileName = isPdf ? fileName.replace(/\.[^.]+$/, '.pdf') : fileName;
    var endpoint = isPdf && 'downloadPdf' || isClean && 'downloadClean' || 'download';
    var handleError = function handleError() {
      dispatch(application.addMessage({
        type: 'error',
        message: isPdf ? 'curie.pdf-generation-failed' : 'curie.file-archived'
      }));
      dispatch({
        type: c.DOWNLOAD_URL_REQUEST_COMPLETE,
        digitalEditIdentity: digitalEditIdentity
      });
    };
    var processResponse = function processResponse(response) {
      if (response.type === 'application/json') {
        throw new Error();
      }
      saveAs(response, downloadFileName);
    };
    dispatch({
      type: c.DOWNLOAD_URL_REQUESTED,
      digitalEditIdentity: digitalEditIdentity
    });
    return dispatch(application.req({
      url: "/api/digital-edit/".concat(digitalEditIdentity, "/").concat(endpoint),
      method: 'get',
      responseType: 'blob',
      timeout: 0,
      validateStatus: function validateStatus(status) {
        return status === 200 || status === 404;
      }
    })).then(processResponse).then(function () {
      return dispatch({
        type: c.DOWNLOAD_URL_REQUEST_COMPLETE,
        digitalEditIdentity: digitalEditIdentity
      });
    }).catch(handleError).then(function () {
      if (!featureEnabled('rubriq_nps_trigger')) {
        return;
      }
      dispatch(application.get('/api/curie/load')).then(function (json) {
        dispatch(_objectSpread({
          type: RUBRIQ_SYNCED
        }, json));
        return json;
      });
    });
  };
};
export var removeDigitalEdit = function removeDigitalEdit(digitalEditIdentity) {
  return {
    type: c.DIGITAL_EDIT_ARCHIVED,
    digitalEditIdentity: digitalEditIdentity
  };
};
export var searchDigitalEdits = function searchDigitalEdits() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return function (dispatch, getState, _ref5) {
    var application = _ref5.application;
    dispatch({
      type: c.DIGITAL_EDIT_SEARCH_REQUESTED
    });
    return dispatch(application.get('/api/digital-edit/search', data)).then(function (json) {
      var digitalEdits = json.results,
        pagination = json.pagination;
      dispatch({
        type: c.DIGITAL_EDIT_SEARCH_COMPLETED,
        pagination: pagination,
        digitalEdits: digitalEdits
      });
      return digitalEdits;
    });
  };
};
export var updateDisplayedDigitalEdits = function updateDisplayedDigitalEdits(identities) {
  return function (dispatch, getState, _ref6) {
    var application = _ref6.application;
    return dispatch(application.get('/api/digital-edit/search', {
      identities: identities
    })).then(function (json) {
      var digitalEdits = json.results;
      var keyedDigitalEdits = _.keyBy(digitalEdits, 'identity');
      dispatch({
        type: c.DIGITAL_EDITS_UPDATED,
        digitalEdits: keyedDigitalEdits
      });
      return true;
    });
  };
};
export var loadDigitalEditing = function loadDigitalEditing() {
  return function (dispatch, getState, _ref7) {
    var application = _ref7.application;
    dispatch(loadUserInvoicingData());
    dispatch(loadPayment());
    return dispatch(application.get('/api/digital-edit/load', {})).then(function (json) {
      var availableDigitalPurchases = json.availableDigitalPurchases,
        digitalEditingPurchase = json.digitalEditingPurchase,
        digitalPurchases = json.digitalPurchases,
        hasDigitalEditingPurchase = json.hasDigitalEditingPurchase,
        hasUploadedDigitalEdit = json.hasUploadedDigitalEdit;
      dispatch({
        availableDigitalPurchases: availableDigitalPurchases,
        digitalEditingPurchase: digitalEditingPurchase,
        digitalPurchases: digitalPurchases,
        hasDigitalEditingPurchase: hasDigitalEditingPurchase,
        hasUploadedDigitalEdit: hasUploadedDigitalEdit,
        type: c.DIGITAL_EDIT_DISPLAY_UPDATED
      });
    });
  };
};
export var getLewisVersion = function getLewisVersion(identity) {
  return function (dispatch, getState, _ref8) {
    var application = _ref8.application;
    return dispatch(application.get("/api/digital-edit/".concat(identity, "/lewis-version")));
  };
};